import React, { Component } from 'react';
import DocumentTitle from 'react-document-title';
import './style.less';

class RulesPageBinguo extends Component {

    render(){
        return(
            <DocumentTitle title={'用户服务协议'}>
                <div className="container customerrules binguo">
                    <h1>宾果英语用户注册协议</h1>
                    <h3>1. 特别提示</h3>
                    <p>
                        1.1 杭州枫桦树教育科技有限公司（以下称“宾果英语”）同意按照本用户注册协议（以下称“本协议”）的规定及其不时发布的操作规则提供基于互联网以及移动网的相关服务（以下称“网络服务”），为获得网络服务，服务使用人（以下称“用户”）应当同意本协议的全部条款并按照页面上的提示完成全部的注册程序。请务必审慎阅读、充分理解本协议各条款内容，请注意免除或限制宾果英语责任的条款、权利许可和信息使用的条款、法律适用和争议解决的条款等。为使容易辨析，免除或限制宾果英语责任的条款已以加粗形式提示用户注意。用户在进行注册程序过程中点击“同意”按钮即表示用户完全接受本协议项下的全部条款。如果用户不同意本协议或其中任何条款约定，应立即停止注册程序，宾果英语也将无法为您提供网络服务。
                        <span>未成年人用户请在父母或监护人陪同下阅读本协议，并在提交个人信息之前寻求父母或监护人的同意和指导。</span>
                    </p>
                    <p>
                        1.2 用户注册成功，用户应当对以其用户帐号进行的所有活动和事件负法律责任。<br/>
                        1.3 用户注册成功，宾果英语将会向每位注册用户拨打电话进一步介绍本公司的相关服务情况。用户的注册行为即视同为同意接受公司进一步的电话服务。<br/>
                        1.4 用户在宾果英语网站或者App内发生的课程购买行为均视为用户本人的真实意思，表示用户本人的行为。本协议通过电子文本形成制成自宾果英语收到用户支付的课程费用起生效，一经成立生效即不可撤销。<br/>
                    </p>
                    <h3>2. 服务内容</h3>
                    <p>
                        2.1 宾果英语网络服务的具体内容由宾果英语根据实际情况提供。<br/>
                        2.2 宾果英语提供的部分网络服务为收费的网络服务，用户使用收费网络服务需要向宾果英语支付一定的费用。对于收费的网络服务，宾果英语会在用户使用之前给予用户明确的提示，只有用户根据提示确认其愿意支付相关费用，用户才能使用该等收费网络服务。如用户拒绝支付相关费用，则宾果英语有权不向用户提供该等收费网络服务。<br/>
                        2.3 用户理解，宾果英语提供的课程是按照用户购买的有效期提供服务，即用户通过宾果英语或宾果英语授权的渠道购买后，即可在所购买的有效期内享受宾果英语提供的网络在线教学等服务。宾果英语承诺按照用户支付时所约定的有效天数为用户提供在线教学服务，超过有效期，用户所购课程将会失效，需由用户重新购买方可继续享受相关服务内容。<br/>
                        2.4 用户理解，宾果英语仅提供相关的网络服务，除此之外与相关网络服务有关的设备（如个人电脑、手机、及其他与接入互联网或移动网有关的装置）及所需的费用（如为接入互联网而支付的电话费及上网费、为使用移动网而支付的手机费）均应由用户自行负担。<br/>
                        2.5 用户理解，为保护宾果英语合法权利，宾果英语有权限制用户同一账号绑定的设备数量为【3】台，同一账号的【3】台设备一经绑定，即不得新增/变更绑定该【3】台设备以外的其他设备。<br/>
                    </p>
                    <h3>3. 服务变更、中断或终止</h3>
                    <p>
                        3.1 鉴于网络服务的特殊性，用户同意宾果英语有权随时变更、中断或终止部分或全部的网络服务（包括收费网络服务）。如变更、中断或终止的网络服务属于免费网络服务，宾果英语无需通知用户，也无需对任何用户或任何第三方承担任何责任；如变更、中断或终止的网络服务属于收费网络服务，宾果英语应当在变更、中断或终止之前事先通知用户，并应向受影响的用户提供等值的替代性的收费网络服务，如用户不愿意接受替代性的收费网络服务，就该用户已经向宾果英语支付的服务费，宾果英语应当按照该用户实际使用相应收费网络服务的情况扣除相应服务费之后将剩余的服务费退还给该用户。<br/>
                        <span>3.2 用户理解，宾果英语需要定期或不定期地对提供网络服务的平台（如互联网网站、移动网络等）或相关的设备进行检修或者维护，如因此类情况而造成收费网络服务在合理时间内的中断，宾果英语无需为此承担任何责任，但宾果英语应尽可能事先进行通告。</span><br/>
                        3.3 如发生下列任何一种情形，宾果英语有权随时中断或终止向用户提供本协议项下的网络服务（包括收费网络服务）而无需对用户或任何第三方承担任何责任：<br/>
                        3.3.1 用户提供的个人资料不真实；<br/>
                        3.3.2 用户违反本协议中规定的使用规则；<br/>
                        3.3.3 用户在使用收费网络服务时未按规定向宾果英语支付相应的服务费。<br/>
                        <span>3.4 如用户注册的免费网络服务的帐号在任何连续180日内未实际使用，或者用户注册的收费网络服务的帐号在其订购的收费网络服务的服务期满之后连续180日内未实际使用，则宾果英语有权删除该帐号并停止为该用户提供相关的网络服务。</span>
                    </p>
                    <h3>4. 使用规则</h3>
                    <p>
                        4.1 用户在申请使用宾果英语网络服务时，必须向宾果英语提供准确的个人资料，如个人资料有任何变动，必须及时更新。<br/>
                        4.2 用户不应将其帐号、密码转让或出借予他人使用。如用户发现其帐号遭他人非法使用，应立即通知宾果英语。因黑客行为或用户的保管疏忽导致帐号、密码遭他人非法使用，宾果英语不承担任何责任。<br/>
                        4.3 用户同意宾果英语有权在提供网络服务过程中以各种方式投放各种商业性广告或其他任何类型的商业信息（包括但不限于在宾果英语网站的任何页面上投放广告），并且，用户同意接受宾果英语通过电子邮件或其他方式向用户发送商品促销或其他相关商业信息。<br/>
                        4.4 对于用户通过宾果英语网络服务（包括但不限于微信服务号、微信老师个人号、论坛、BBS、教育问答）上传到宾果英语网站上可公开获取区域的任何内容，用户同意宾果英语在全世界范围内具有免费的、永久性的、不可撤销的、非独家的和完全再许可的权利和许可，以使用、复制、修改、改编、出版、翻译、据以创作衍生作品、传播、表演和展示此等内容（整体或部分），和/或将此等内容编入当前已知的或以后开发的其他任何形式的作品、媒体或技术中。<br/>
                        4.5 用户在使用宾果英语网络服务过程中，必须遵循以下原则：<br/>
                        4.5.1 遵守中国有关的法律和法规；<br/>
                        4.5.2 遵守所有与网络服务有关的网络协议、规定和程序；<br/>
                        4.5.3 不得为任何非法目的而使用网络服务系统；<br/>
                        4.5.4 不得以任何形式使用宾果英语网络服务侵犯宾果英语的商业利益，包括并不限于发布非经宾果英语许可的商业广告；<br/>
                        4.5.5 不得利用宾果英语网络服务系统进行任何可能对互联网或移动网正常运转造成不利影响的行为；<br/>
                        4.5.6 不得利用宾果英语提供的网络服务上传、展示或传播任何虚假的、骚扰性的、中伤他人的、辱骂性的、恐吓性的、庸俗淫秽的或其他任何非法的信息资料；<br/>
                        4.5.7 不得侵犯其他任何第三方的专利权、著作权、商标权、名誉权或其他任何合法权益；<br/>
                        4.5.8 不得利用宾果英语网络服务系统进行任何不利于宾果英语的行为；<br/>
                        <span>4.6 宾果英语有权对用户使用宾果英语网络服务的情况进行审查和监督(包括但不限于对用户存储在宾果英语的内容进行审核)，如用户在使用网络服务时违反任何上述规定，宾果英语或其授权的人有权要求用户改正或直接采取一切必要的措施（包括但不限于更改或删除用户张贴的内容等、暂停或终止用户使用网络服务的权利）以减轻用户不当行为造成的影响。</span><br/>
                        <span>4.7 宾果英语针对某些特定的宾果英语网络服务的使用通过各种方式（包括但不限于网页公告、电子邮件、服务号消息提醒、短信提醒等）作出的任何声明、通知、警示等内容视为本协议的一部分，用户如使用该等宾果英语网络服务，视为用户同意该等声明、通知、警示的内容。</span><br/>
                        <span>4.8 凡用户昵称中出现如下信息者（包括但不限于），宾果英语有权进行屏蔽、锁定，甚至注销：</span><br/>
                        4.8.1.使用严重违反国家法律法规及风序良俗，包含或暗藏反动、色情等信息（含符号、地址等）的昵称；<br/>
                        4.8.2.使用党和国家领导人、古今中外比较有影响的名人、网络上知名人士的真实姓名、字、号、艺名、笔名、头衔等为昵称；<br/>
                        4.8.3.使用国家机构、企事业单位、知名公司或品牌的名称及标识为昵称；<br/>
                        4.8.4.含性别歧视、种族歧视、地域歧视等信息的昵称；<br/>
                        4.8.5.含自侮辱、猥亵或者对他人进行侮辱、挑衅、漫骂、人身攻击等不文明、不健康信息的昵称；<br/>
                        4.8.6.含易产生歧义、引起他人误解的信息的昵称；<br/>
                        4.8.7.未获得宾果英语官方正式许可而使用带有宾果英语相关名称的昵称；<br/>
                        4.8.8.与宾果英语老师、及社区管理人员的昵称近似或雷同，并可能引起混淆或纠纷的；<br/>
                        4.8.9.带有明显广告性质的昵称；<br/>
                        4.8.10.带有其它法律法规以及宾果英语规则中所禁止信息的昵称。
                    </p>
                    <h3>5. 上课规定</h3>
                    <p>
                        5.1. 为确保所在班级良好的课堂氛围，用户应协助宾果英语，保障学员在上课过程中不吵闹，不迟到，不早退。<br/>
                        5.2. 如遇特殊原因，宾果英语在告知用户的同时有权对用户上课账号做静音、下线等处理。<br/>
                        5.3. 用户或学员在课程进行中如存在以下情形，宾果英语或外教有权中止课程服务，且扣除课时；同时有权删除该次课程服务的全部视频，且无须承担任何法律后果：<br/>
                        5.3.1衣着暴露，包括但不限于裸露身体隐私部位等；<br/>
                        5.3.2 多个孩子上课或非本协议约定的学员本人上课，包括但不限于成人代替上课等；<br/>
                        5.3.3 家暴行为或者不适当的管教行为，包括惩罚性的肢体接触或者严重辱骂等；<br/>
                        5.3.4使用危险的用具，包括但不限于刀具、仿真枪等；<br/>
                        5.3.5损害国家的尊严或者利益，泄露国家秘密；<br/>
                        5.3.6危害人身、财产安全，泄露个人隐私；<br/>
                        5.3.7妨碍社会公共秩序或者违背社会良好风尚；<br/>
                        5.3.8有淫秽、色情、赌博、迷信、恐怖、暴力相关的言行；<br/>
                        5.3.9有民族、种族、宗教、性别歧视相关的言行；<br/>
                        5.3.10对外教进行攻击性、歧视性的言行；<br/>
                        5.3.11违反中华人民共和国法律法规的其他行为；<br/>
                        5.3.12 违反外教所在地相关法律或乙方平台规则的行为；<br/>
                        5.3.13 宾果英语合理认定应当对用户中止课程服务或删除相关视频的其他行为。
                    </p>
                    <h3>6. 只是产权</h3>
                    <p>
                        <span>6.1 宾果英语提供的网络服务中包含的任何文本、图片、图形、音频和/或视频资料均受版权、商标和/或其它财产所有权法律的保护，未经相关权利人同意，上述资料均不得在任何媒体直接或间接发布、播放、出于播放或发布目的而改写或再发行，或者被用于其他任何商业目的。所有这些资料或资料的任何部分仅可作为私人和非商业用途而保存在某台计算机内。就由上述资料产生或在传送或递交全部或部分上述资料过程中产生的延误、不准确、错误和遗漏或从中产生或由此产生的任何损害赔偿，宾果英语不以任何形式，向用户或任何第三方负责。</span><br/>
                        6.2 宾果英语为提供网络服务而使用的任何软件（包括但不限于软件中所含的任何图象、照片、动画、录像、录音、音乐、文字和附加程序、随附的帮助材料）的一切权利均属于该软件的著作权人，未经该软件的著作权人许可，用户不得对该软件进行反向工程（reverse engineer）、反向编译（decompile）或反汇编（disassemble）。<br/>
                    </p>
                    <h3>7. 免责声明</h3>
                    <p>
                        <span>7.1 用户明确同意其使用宾果英语网络服务所存在的风险将完全由其自己承担；因其使用宾果英语网络服务而产生的一切后果也由其自己承担，宾果英语对用户不承担任何责任。</span><br/>
                        <span>7.2 宾果英语不担保网络服务一定能满足用户的要求，也不担保网络服务不会中断，对网络服务的及时性、安全性、准确性也都不作担保。</span><br/>
                        <span>7.3 宾果英语不保证为向用户提供便利而设置的外部链接的准确性和完整性，同时，对于该等外部链接指向的不由宾果英语实际控制的任何网页上的内容，宾果英语不承担任何责任。</span><br/>
                        <span>7.4 对于因不可抗力或宾果英语不能控制的原因造成的网络服务中断或其它缺陷，宾果英语不承担任何责任，但将尽力减少因此而给用户造成的损失和影响。</span><br/>
                        <span>7.5 用户理解并同意，对于宾果英语向用户提供的下列产品或者服务的质量缺陷本身及其引发的任何损失，宾果英语无需承担任何责任：</span><br/>
                        7.5.1 宾果英语向用户免费提供的各项网络服务；<br/>
                        7.5.2 宾果英语向用户赠送的任何产品或者服务；<br/>
                        7.5.3 宾果英语向收费网络服务用户附赠的各种产品或者服务。
                    </p>
                    <h3>8. 违约赔偿</h3>
                    <p>
                        <span>8.1 如因宾果英语违反有关法律、法规或本协议项下的任何条款而给用户造成损失，宾果英语同意承担由此造成的损害赔偿责任。</span><br/>
                        <span>8.2 用户同意保障和维护宾果英语及其他用户的利益，如因用户违反有关法律、法规或本协议项下的任何条款而给宾果英语或任何其他第三人造成损失，用户同意承担由此造成的损害赔偿责任。</span><br/>
                    </p>
                    <h3>9. 协议修改</h3>
                    <p>
                        <span>9.1 宾果英语有权随时修改本协议的任何条款，一旦本协议的内容发生变动，宾果英语将会直接在宾果英语网站或者App用户注册页面上公布修改之后的协议内容，该公布行为视为宾果英语已经通知用户修改内容。宾果英语也可通过其他适当方式向用户提示修改内容。</span><br/>
                        <span>9.2 如果不同意宾果英语对本协议相关条款所做的修改，用户有权停止使用网络服务。如果用户继续使用网络服务，则视为用户接受宾果英语对本协议相关条款所做的修改。</span><br/>
                    </p>
                    <h3>10. 通知送达</h3>
                    <p>
                        10.1 本协议项下宾果英语对于用户所有的通知均可通过网页公告、电子邮件、手机短信或常规的信件传送等方式进行；该等通知于发送之日视为已送达收件人。<br/>
                        10.2 用户对于宾果英语的通知应当通过宾果英语对外正式公布的通信地址、联系电话等联系信息进行送达。<br/>
                        公司名称：杭州枫桦树教育科技有限公司<br/>
                        经营地址：浙江省杭州市拱墅区康中路16号3幢3层311室<br/>
                        联系电话：0571-88321763
                    </p>
                    <h3>11. 法律管辖</h3>
                    <p>
                        <span>11.1 本协议的订立、执行和解释及争议的解决均应适用中国法律并受中国法院管辖。</span><br/>
                        <span>11.2 如双方就本协议内容或其执行发生任何争议，双方应尽量友好协商解决；协商不成时，任何一方均可向宾果英语所在地的人民法院提起诉讼。</span><br/>
                    </p>
                    <h3>11. 其他规定</h3>
                    <p>
                    12.1 本协议构成双方对本协议之约定事项及其他有关事宜的完整协议，除本协议规定的之外，未赋予本协议各方其他权利。<br/>
                    12.2 如本协议中的任何条款无论因何种原因完全或部分无效或不具有执行力，本协议的其余条款仍应有效并且有约束力。<br/>
                    12.3 本协议中的标题仅为方便而设，在解释本协议时应被忽略。 <br/>
                    </p>
                </div>
            </DocumentTitle>
        )
    }
}

export default RulesPageBinguo;



// WEBPACK FOOTER //
// ./src/components/customerPage/RulesPageBinguo.jsx